import React from "react";
import ContactForm from "../components/ContactForm";

const Contact = () => {
  return (
    <div className="bg-[#05070d]">
      <section className="relative pt-36 pb-8 bg-gradient-to-br from-[#05070d] via-[#0b1220] to-[#05070d]">
        <div className="absolute inset-0 dark-grid" />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8">
          <span className="text-xs font-semibold tracking-[0.25em] text-blue-400">CONTACT</span>
          <h1 className="mt-3 text-4xl md:text-5xl font-bold tracking-tight text-white max-w-3xl">
            Let’s talk about your IT.
          </h1>
        </div>
      </section>
      <ContactForm />
    </div>
  );
};

export default Contact;
